angular.module('dnecom')
    .controller('ProductProcessController', ["$scope", "ProductUtils", "StoreUtils", "notifications", "IdleWatcher", "MediaSrc", "StorageBag", "ErrorBag", function ProductProcessController($scope, ProductUtils, StoreUtils, notifications, IdleWatcher, MediaSrc, StorageBag, ErrorBag) {
        $scope.product = ProductUtils.getProduct();
        $scope.mode = $scope.product.status === 'initial' ? 'add' : 'edit';
        $scope.variantsCount = 0;
        $scope.quantityTooltip = 'Your ' + ($scope.product.type == 1 ? 'service' : 'product') + ' quantity goes here';

        $scope.errorMessages = [];

        if ($scope.product.status === 'initial') {
            $scope.product.status = 'draft';
            $scope.mode = 'add';
        } else {
            $scope.mode = 'edit';
        }

        if (!$scope.product.properties) {
            $scope.product.properties = {};
        }

        if (!$scope.product.properties.og) {
            $scope.product.properties.og = {};
        }

        if (!$scope.product.properties.base) {
            $scope.product.properties.base = {};
        }

        if (!$scope.product.properties.details) {
            $scope.product.properties.details = {};
        }

        $scope.originalProduct = angular.copy($scope.product);

        var defaultProductTemplate = '<div style="color: rgb(0, 0, 0);"><h3>Description:</h3><ul><li>...</li><li>...</li><li>...</li><li>...</li><li>...</li></ul><p><strong>Guaranteed safe checkout:</strong> PAYPAL | VISA | MASTERCARD</p><p>Click \'Add To Cart\' button to order yours now!</p><p><em>(You will receive your order within ___ days)</em></p></div>';

        $scope.store = TemplateData.value('store');
        $scope.productDescriptionTemplates = [
            {
                title: 'Basic',
                content: defaultProductTemplate
            }
        ];

        var product_autosave = StorageBag.get('product_autosave_enabled');
        if (_.isUndefined(product_autosave)) {
            $scope.autosaveEnabled = true;
        } else {
            $scope.autosaveEnabled = StorageBag.get('product_autosave_enabled') == 1;
        }

        $scope.isEdit = function() {
            return $scope.mode === 'edit';
        };

        $scope.isNew = function() {
            return $scope.mode === 'add';
        };

        $scope.isSavePending = function() {
            return $scope.saveIsPending;
        };

        $scope.isDraft = function() {
            return $scope.product.status === 'draft';
        };

        $scope.productChanged = function() {
            return !angular.equals($scope.originalProduct, $scope.product);
        };

        $scope.toggleAutosave = function() {
            $scope.autosaveEnabled = !$scope.autosaveEnabled;
            var value = $scope.autosaveEnabled ? 1 : 0;
            StorageBag.put('product_autosave_enabled', value);
        };

        IdleWatcher.create($scope, 'product', function() {
            function shouldAutoSave() {
                return $scope.autosaveEnabled
                    && !$scope.isSavePending()
                    && $scope.productChanged()
                    && $scope.product.title
                    && $scope.product.title.length > 0
                    && $scope.product.regularPrice;
            }

            if (shouldAutoSave()) {
                $scope.save($scope.form);
            }
        });

        window.onbeforeunload = function(e) {
            return $scope.productChanged() ? 'Are you sure you want to leave?' : null;
        };

        if ($scope.isNew() && !$scope.product.description) {
            $scope.product.description = defaultProductTemplate;
        }

        $scope.checkInvalidFields = function(){
            setTimeout(function(){
                if ($('.has-error').length > 0) {
                    $('body').scrollTop($('.has-error').first().offset().top - 150);
                }
            }, 60);
        };

        $scope.onFieldUpdate = function(key) {
            if ($scope.form[key]) {
                $scope.form[key].$setValidity('customMessage_' + key, true);
                $scope.form[key].$validate();
            }
        };

        $scope.save = function(form) {
            form.$setTouched();
            $scope.$broadcast('product.touchPartials');

            if (form.$invalid
                //prevent submit if product is not service type and doesn't have categories
                || (!$scope.isDraft()
                    && $scope.product.type != 1
                    && (!$scope.product.category
                        || !$scope.product.googleProductCategory
                        || !$scope.product.shippingZones.length
                    )
                )
                //prevent submit if have checked save for future use and dont have instruction name
                || ($scope.product.type == 1
                    && $scope.product.instructionSave
                    && (!$scope.product.instruction || !$scope.product.instruction.name)
                )
            ) {
                createPopupError(form);
                return;
            }

            doSave();
        };

        $scope.publishProduct = function() {
            $scope.product.status = 'public';

            doSave();
        };

        $scope.getMediaSrc = function(media) {
            return MediaSrc.src(media);
        };

        $scope.setOriginalProduct = function (product) {
            $scope.originalProduct = angular.copy(product);
        };

        $scope.pageScrollTop = function(){
            var body = $("html, body");
            body.stop().animate({scrollTop:0}, '500', 'swing');
        };

        $scope.getDesignImageUrl = function() {
            var images = $scope.product.properties.details.sourceData.images;
            var key = Object.keys(images).length ? Object.keys(images)[0] : null;

            return key ? images[key] : null;
        };

        function createPopupError(form) {
            var error = '* IMPORTANT INPUT IS MISSING! *</br>' +
                'To save the product, please update:';
            if (!$scope.product.name) {
                error += '</br>- Product name'
            }
            if (!$scope.product.title) {
                error += '</br>- Product title'
            }
            if (!$scope.product.slug) {
                error += '</br>- Product page url'
            }
            if (!$scope.product.regularPrice) {
                error += '</br>- Regular price'
            }

            if ($scope.product.type == 1 && $scope.product.instructionSave && (!$scope.product.instruction || !$scope.product.instruction.name)) {
                error += '</br>- Customer service instruction name'
            }

            if (!$scope.isDraft() && !$scope.product.category) {
                $scope.$broadcast('toogle:panel-collapse', {panelId: 'panel-' + $scope.store.id + '-process-category'})
                error += '</br>- Product category'
            }
            if (!$scope.isDraft() && !$scope.product.googleProductCategory && $scope.product.type != 1) {
                $scope.$broadcast('toogle:panel-collapse', {panelId: 'panel-' + $scope.store.id + '-process-category'})
                error += '</br>- Google product category'
            }
            if (!$scope.isDraft() && $scope.product.type != 1 && !$scope.product.shippingZones.length) {
                $scope.$broadcast('toogle:panel-collapse', {panelId: 'panel-process-shipping'})
                error += '</br>- At least one shipping zone is required'
            }
            if (form.sourceUrl.$invalid) {
                $scope.$broadcast('toogle:panel-collapse', {panelId: 'panel-' + $scope.store.id + '-process-source'})
                error += '</br>- Product source url'
            }
            if ($scope.product.linkedProduct && !$scope.product.properties.linkedData.name) {
                $scope.$broadcast('toogle:panel-collapse', {panelId: 'link-products'})
                error += '</br>- Linked product -> Current product'
            }
            if ($scope.product.linkedProduct && !$scope.product.linkedProduct.linkedName) {
                $scope.$broadcast('toogle:panel-collapse', {panelId: 'link-products'})
                error += '</br>- Linked product -> Linked product'
            }
            notifications.danger(error);
        }

        function doSave() {
            if ($scope.isSavePending()) {
                return;
            }

            $scope.saveIsPending = true;

            $scope.$broadcast('product.beforeSave');

            ProductUtils.save($scope.store, $scope.product, function(response) {
                $scope.saveIsPending = false;

                if (!response.data.success) {
                    if (response.data.hasOwnProperty('errors')) {
                        $.each(response.data.errors, function(key, value) {
                            if ($scope.form[key]) {
                                $scope.form[key].$invalid = true;
                                $scope.form[key].$touched = true;

                                $scope.errorMessages.push({
                                    type: 'customMessage_' + key,
                                    text: value[0]
                                });

                                $scope.form[key].$setValidity('customMessage_' + key, false);
                            }
                        });
                    }

                    notifications.danger('Failed to save product - some fields are not valid.');
                    $scope.checkInvalidFields();
                    return;
                }

                $scope.product.id = response.data.id;
                $scope.product.hash = response.data.hash;
                $scope.product.sku = response.data.sku;

                var currentPrice = parseFloat(response.data.product.currentPrice);
                if (!isNaN(currentPrice)) {
                    $scope.product.currentPrice = currentPrice.toFixed(2);
                }

                $scope.product.category = response.data.product ? response.data.product.category : null;

                if (response.data['product'] && response.data['product']['gallery']) {
                    $scope.product.gallery = response.data.product.gallery;
                }

                if (response.data['product'] && response.data['product']['framedOgImage']) {
                    $scope.product.framedOgImage = response.data.product.framedOgImage;
                } else {
                    $scope.product.framedOgImage = null;
                }

                if (response.data['product'] && response.data['product']['ogImageFrame']) {
                    $scope.product.ogImageFrame = response.data.product.ogImageFrame;
                }

                if (response.data['product'] && response.data['product']['primaryImage']) {
                    $scope.product.primaryImage = response.data.product.primaryImage;
                } else {
                    $scope.product.primaryImage = null;
                }

                $scope.product.watermarkEnabled = _.get(response, 'data.product.watermarkEnabled');
                $scope.product.watermarkType = _.get(response, 'data.product.watermarkType');
                $scope.product.watermarkContentType = _.get(response, 'data.product.watermarkContentType');
                $scope.product.watermarkBackgroundColor = _.get(response, 'data.product.watermarkBackgroundColor');

                $scope.setOriginalProduct($scope.product);

                $scope.$broadcast('product.afterSave', {
                    product: $scope.product
                });
                
                notifications.success(response.data.message);
            });
        };

        $scope.$on('product.variants.appeared', function($event, value) {
            $scope.quantityTooltip = (value.length > 0)
                ? 'Quantity is controlled from the ' + ($scope.product.type == 1 ? 'Service' : 'Product') + ' Variants section below.'
                : 'Your ' + ($scope.product.type == 1 ? 'service' : 'product') + ' quantity goes here';
            $scope.variantsCount = value.length;
        });
    }]);
